import React, { FunctionComponent } from 'react'
import GenericGameStep from '../../components/GenericGameStep'
import LotteryV2StepType from '@tootsweet/model/lottery/LotteryV2StepType'
import PollModalContent from './GenderAndAgeModalContent'
import { useSelector } from 'react-redux'
import {
  loadingSelector,
  lotteryConfigSelector,
  prizeSelector,
  venueSelector,
  wheelLabelsSelector,
} from '../../redux/selectors/lottery'

interface Props {}

const GenderAndAge: FunctionComponent<Props> = () => {
  const venue = useSelector(venueSelector)
  const wheelLabels = useSelector(wheelLabelsSelector)
  const prize = useSelector(prizeSelector)
  const loading = useSelector(loadingSelector)
  const lotteryConfig = useSelector(lotteryConfigSelector)

  if (!venue?.name) return null
  return (
    <GenericGameStep
      wheelLabels={wheelLabels}
      prize={prize}
      loading={loading}
      finalPlaceName={venue?.name}
      lotteryConfig={lotteryConfig}
      stepType={LotteryV2StepType.Poll}
      renderModalBody={() => {
        if (!venue?.name) return null
        return <PollModalContent finalPlaceName={venue?.name} />
      }}
    />
  )
}

export default GenderAndAge
